import { LazyRoute } from "common/routes/route.types";
import { routes } from "common/routes/routes";

export const bookingRoutesBase: LazyRoute[] = [
  {
    importComponent: () => import("modules/booking/BookingSideNavLayout"),
    id: "booking-layout",
    children: [
      {
        index: true,
        importComponent: () =>
          import("modules/booking/pages/practice-profile/PracticeProfileEdit"),
        id: "booking-index"
      },
      {
        ...routes.appointmentBooking.onlineConfig,
        importComponent: () =>
          import("modules/booking/pages/practice-profile/PracticeProfileEdit"),
        id: routes.appointmentBooking.onlineConfig.text
      },
      {
        ...routes.appointmentBooking.onlineSettings,
        importComponent: () => import("modules/booking/pages/online-settings"),
        id: routes.appointmentBooking.onlineSettings.text
      },
      {
        ...routes.appointmentBooking.appointmentTypes,
        importComponent: () => import("modules/booking/pages/appointmentTypes"),
        id: routes.appointmentBooking.appointmentTypes.text
      },
      {
        ...routes.appointmentBooking.providers,
        importComponent: () => import("modules/booking/pages/providers"),
        id: routes.appointmentBooking.providers.text
      },
      {
        ...routes.appointmentBooking.exclusionPeriods,
        importComponent: () =>
          import("modules/booking/pages/exclusion-periods"),
        id: routes.appointmentBooking.exclusionPeriods.text
      }
    ]
  },
  {
    ...routes.appointmentBooking.providersEdit,
    importComponent: () => import("modules/booking/pages/providers-edit"),
    id: routes.appointmentBooking.providersEdit.text
  }
];

export const bookingRoutes: LazyRoute = {
  ...routes.appointmentBooking.basePath,
  importComponent: () => import("modules/booking/Index"),
  children: bookingRoutesBase,
  id: "booking-base"
};
